import { ServiceFilter } from '@prisma/client'

export const SERVICE_FILTER_LABELS: { [key in ServiceFilter]: string } = {
  [ServiceFilter.DraughtProofing]: 'Draught proofing',
  [ServiceFilter.LoftInsulation]: 'Loft insulation',
  [ServiceFilter.WallInsulation]: 'Wall insulation',
  [ServiceFilter.UnderfloorInsulation]: 'Underfloor insulation',
  [ServiceFilter.Windows]: 'Windows',
  [ServiceFilter.HeatPumpInstallation]: 'Heat pump installation',
  [ServiceFilter.PlumbingServices]: 'Plumbing services',
  [ServiceFilter.SolarInstallation]: 'Solar installation',
}
